/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {CalendarMonthOutlined, Flag, WalletOutlined} from "@mui/icons-material";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import {useEffect, useState} from "react";
import Zoom from "react-medium-image-zoom";

const Formulario_Historial = ({...props}) => {
    const [imagen, setImagen] = useState('')
    const [fechaRes, setFechaRes] = useState(false)

    useEffect(() => {
        let im = props.props.getValues('img')
        let fec = props.props.getValues('fechaRespuesta')
        setImagen(im)
        if (fec){
            setFechaRes(true)
        }
    }, []);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    {fechaRes &&
                    <IngresoFecha Icono={CalendarMonthOutlined} nombre={'Fecha de Respuesta'}
                                  dato={'fechaRespuesta'} {...props}
                                  editable={false}
                    />
                    }
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={WalletOutlined} nombre={'Wallet Involucrada'} dato={'tipo'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={WalletOutlined} nombre={'Monto Involucrado'} dato={'valor'} {...props}
                                   editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={''} dato={'detalle'} {...props} editable={false}
                    />
                </Grid>

                {imagen &&
                    <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center'}}>
                        <Zoom>
                            <img src={imagen} width={'100%'} height={'auto'}/>
                        </Zoom>
                    </Grid>
                }


            </Grid>

        </form>

    )

}
export default Formulario_Historial